import React from "react";
import { useTheme } from "../lib/theme-context";
import { useLang } from "../lib/lang-context";
import { Sun, Moon } from "@phosphor-icons/react";

export default function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const { t } = useLang();
  const isDark = theme === "dark";
  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label={isDark ? t.theme.toggleLight : t.theme.toggleDark}
      className={`flex items-center justify-center w-9 h-9 border border-white/20 hover:border-white/50 text-white/80 hover:text-white transition-all rounded-sm ${className}`}
    >
      {isDark ? <Sun size={16} weight="bold" /> : <Moon size={16} weight="bold" />}
    </button>
  );
}
